module.exports = __webpack_public_path__ + "media/assets/EllipseRed-40bdd5aa594e78f3652f4d67d8fd82b6.svg";